import React from "react"
import { useForm, ValidationError } from "@formspree/react"
import { SatisfactionField, RadioField, HiddenField, SubmitButton } from "./FormFields"
import { useLocation } from "../../hooks/use-location"

const formId = process.env.GATSBY_POST_SURVEY_FORM

const PostSurveyForm = ({ survey }) => {
  const { href } = useLocation()
  const [state, handleSubmit] = useForm(formId)

  if (state.succeeded) {
    return <div className="postform-survey">
      <div className="description">
        <p><span className="text-bold">¡Gracias por tu respuesta, nos ayudará mucho!</span></p>
      </div>
    </div>
  }

  const sourceOptions = [
    { text: 'Google', value: 'Google' },
    { text: 'Facebook', value: 'Facebook' },
    { text: 'Linkedin', value: 'Linkedin' },
    { text: 'Email', value: 'Email' },
    { text: 'Instagram', value: 'Instagram' },
    { text: 'Youtube', value: 'Youtube' },
    { text: 'Recomendación', value: 'Referral' },
    { text: 'Evento', value: 'Event' }
  ]

  return (
    <div className="postform-survey">
      <div className="postform-description">
        <p>Ayudanos a mejorar la experiencia de nuestros clientes</p>
      </div>
      <div className="survey">
        <form className="form-fields" onSubmit={handleSubmit}>
          <SatisfactionField id="satisfaction" text="¿Cómo fue tu experiencia en el sitio?" required={true} />
          <RadioField id="source" text="¿Dónde nos descubriste?" options={sourceOptions} required={true} />
          <HiddenField id="form" value={survey} />
          <HiddenField id="site" value={href} />
          <ValidationError className="errors" errors={state.errors} />
          <SubmitButton text={ state.submitting ? `Enviando...` : `Enviar` } disabled={state.submitting} />
        </form>
        <p className="bottom">Los datos serán registrados anónimamente</p>
      </div>
    </div>
  )
}

export default PostSurveyForm